module.exports = __webpack_public_path__ + "629ca770ab452084fad75fa805a75972.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-768.jpg
// module id = 623
// module chunks = 0